import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../assets/star.gif'


import { StyleValue } from "vue";
interface TitleStarProps {
  size: number;
  style?: StyleValue;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Stars',
  props: {
    size: null,
    style: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style['stars']),
    style: _normalizeStyle(__props.style)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(__props.size).keys()], (_, index) => {
      return (_openBlock(), _createElementBlock("img", {
        src: _imports_0,
        alt: "",
        key: index
      }))
    }), 128))
  ], 6))
}
}

})